export enum ReviewStatus {
  Unassigned = 'unassigned',
  Pending = 'pending',
  Completed = 'completed',
  ConflictOfInterest = 'conflictofinterest',
}
